import { useEffect, useState } from "react";

const LOGO =
  "https://customer-assets.emergentagent.com/wingman/85cf05f2-d849-40c8-9fc9-80449c196070/attachments/71b336acd64a487ea8f6710e443d86c9_FullColor_TransparentBg_1280x1024_72dpi.png";

const LINKS = [
  { href: "/#about", label: "About" },
  { href: "/#services", label: "Services" },
  { href: "/#bonsai", label: "Bonsais" },
  { href: "/journal", label: "Journal" },
  { href: "/#faq", label: "FAQ" },
  { href: "/#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F9F8F6]/85 backdrop-blur-xl border-b border-[#E5E1DB]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 flex items-center justify-between h-20">
        <a
          href="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO}
            alt="Indoor Greens"
            className="h-10 w-auto object-contain"
          />
          <span className="hidden sm:inline-block font-[Outfit] font-light tracking-[0.25em] text-[#2D332B] text-xs uppercase">
            Indoor Greens
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-underline text-[13px] tracking-[0.2em] uppercase text-[#2D332B] hover:text-[#8A9A86] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="/#contact"
          data-testid="nav-cta-enquire"
          className="hidden md:inline-flex items-center px-5 py-2.5 text-[12px] tracking-[0.22em] uppercase border border-[#2D332B] text-[#2D332B] hover:bg-[#2D332B] hover:text-[#F9F8F6] transition-colors duration-500 rounded-sm"
        >
          Enquire
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#2D332B]"
        >
          <span className="block w-6 h-px bg-current mb-1.5" />
          <span className="block w-6 h-px bg-current mb-1.5" />
          <span className="block w-4 h-px bg-current ml-auto" />
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#F9F8F6] border-t border-[#E5E1DB] px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-[0.2em] uppercase text-[#2D332B]"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
